<template>
  <div class="app-container">
    <div class="img">
      <img src="../../assets/img/inviteBack.jpg" alt="" srcset="" />
      <div class="btn1" @click="toDevice(0, 2)">
        <img src="../../assets/img/inviteBtn.jpg" alt="" />
      </div>
    </div>
    <invite-pop v-if="inviteVisable" @close="close"></invite-pop>
  </div>
</template>

<script>
import invitePop from "./pop/invitePop.vue";
export default {
  name: "",
  components: {
    invitePop,
  },
  data() {
    return {
      inviteVisable: false,
    };
  },
  beforeCreate() {},
  created() {},
  methods: {
    toDevice() {
      let obj = this.$store.getters;
      if (obj.token) {
        this.inviteVisable = true;
      } else {
        //去登录
        this.$message.warning("请先登录");
      }
    },
    close() {
      this.inviteVisable = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  // min-width: 1440px;
  max-width: 1920px;
  background: #fff;
  margin: 0 auto;
}
.img {
  position: relative;
  width: 80%;
  margin: 0 auto;
  img {
    width: 100%;
  }
  .btn1 {
    position: absolute;
    width: 80%;
    right: 1.5%;
    top: 75.9%;
    cursor: pointer;
    img {
      width: 80%;
      cursor: pointer;
    }
  }
}
</style>
